import script from "./DocumentsInfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentsInfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentsInfoPanel.vue?vue&type=style&index=0&id=27c70656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c70656"]])

export default __exports__